// Import src/elements.js directly otherwise Parcel build fails
import * as baseElements from 'typed-html/dist/src/elements.js';

export type DataAttributes = Record<string, string | number | boolean | null | undefined>;

Array.prototype.toString = function () {
  return this.join('');
};

export function Fragment(props: { children?: JSX.Element[] }) {
  return props.children?.join('');
}

function createElement(name: any, attrs: any, ...children: any[]) {
  if (attrs) {
    const filteredAttrs: Record<string, any> = {};
    for (const key in attrs) {
      if (attrs[key] !== undefined) {
        filteredAttrs[key] = attrs[key];
      }
    }
    delete filteredAttrs.__source;
    delete filteredAttrs.__self;
    attrs = filteredAttrs;
  }
  return baseElements.createElement(name, attrs, ...children);
}

export const elements = {
  ...baseElements,
  createElement,
};
